import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore";
import { db } from "../firebase";
import UserController from "./UserController";
import Theme from "../models/Theme";

const getSelectedTheme = async (user_id: string): Promise<Theme | null> => {
    const user = await UserController.getUser(user_id);
    if(!user.selectedTheme) {
        return null;
    }
    const colRef = collection(db, "theme");
    const themeRef = doc(colRef, user.selectedTheme);
    const themeSnapshot = await getDoc(themeRef);
    return themeSnapshot.data() as Theme;
}

const getThemes = async (user_id: string): Promise<Theme[]> => {
    const colRef = collection(db, "theme");
    const q = query(colRef, where("user_id", "==", user_id));
    const themeSnapshot = await getDocs(q);
    const themes: Theme[] = [];
    for(const theme of themeSnapshot.docs) {
        const themeData = theme.data() as Theme;
        themeData.uid = theme.id;
        themes.push(themeData);
    }
    return themes;
}

const createTheme = async (user_id: string, name: string, font: string, colors: Theme["colors"]): Promise<Theme> => {
    const theme: Partial<Theme> = {
        user_id,
        name,
        font,
        colors,
        createdAt: Timestamp.fromDate(new Date()),
        updatedAt: Timestamp.fromDate(new Date()),
    }
    try{
        const docRef = await addDoc(collection(db, "theme"), theme);
        return { ...theme, uid: docRef.id } as Theme;
    } catch (error) {
        console.error("Error creating theme:", error);
        throw new Error("Failed to create theme");
    }
}

const updateTheme = async (theme_id: string, font: string, colors: Theme["colors"]): Promise<void> => {
    const docRef = doc(db, "theme", theme_id)
    await updateDoc(docRef, {
        font,
        colors
    })
}

const ThemeController = {
    getSelectedTheme,
    getThemes,
    updateTheme,
    createTheme
}

export default ThemeController;